import styled from "styled-components";
import { Button } from "reactstrap";

export const ErrorContainer = styled.div`
    width: 100%;
    padding: 40px 20px;
    text-align: center;
`;

export const RetryButton = styled(Button)`
    width: 200px;
    color: white;
`;
